import { useAuthTokenDataQuery } from 'hooks/queries/useAuthTokenDataQuery';

export const useUserPermissionsQuery = () => {
  const token = useAuthTokenDataQuery();

  return token ? token.permissions : undefined;
};
